import React from 'react';
import { Field } from 'formik';
import { FsProps } from './FsProps';
import { FieldSelectDB } from './field-select-db';
import { CustomSelectComponent } from './custom-select';

import { gql, useLazyQuery } from '@apollo/client';
const gqlGetValues = gql`
  query getWasteTransactionTypes(
    $where: String
    $offset: Int
    $limit: Int
    $order: String
  ) {
    getWasteTransactionTypes(
      where: $where
      offset: $offset
      limit: $limit
      order: $order
    ) {
      data {
        description: name
        id: value
      }
      recordCount
    }
  }
`;
function useGetValues() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'network-only' });
}
const FsWtType = ({
  label = 'Επιλογή',
  name,
  disable = false,
  ...rest
}: FsProps & { readonly disable?: boolean }) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore

      hook={useGetValues}
      isMulti={false}
    />
  );
};
export default FsWtType;

